import React, { ReactNode } from 'react'

type CardDetailsProps = {
  details:string | ReactNode;
}

export default function CardDetails({details}:CardDetailsProps) {
  return (
    <div className="font-light text-wrap">{details}</div>
  )
}
